import { render, staticRenderFns } from "./algorithmAllocation.vue?vue&type=template&id=2a738f27&scoped=true"
import script from "./algorithmAllocation.vue?vue&type=script&lang=js"
export * from "./algorithmAllocation.vue?vue&type=script&lang=js"
import style0 from "./algorithmAllocation.vue?vue&type=style&index=0&id=2a738f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a738f27",
  null
  
)

export default component.exports